<template>
    <div id="start_modal_wrap">
        <span class="start_modal_overlay"></span>
        <div class="start_modal">
            <div class="start_modal_inner">
                <div class="start_modal_close" @click="closeIt"><span class="material-symbols-outlined">close</span></div>
                <div class="start_modal_inner_wrap">

                    <div class="each_wrap centered">
                        <div class="info_wrap s-overflow-wrap">
                            <div v-if="isVideo || isImage" class="media_wrap">
                                <video v-if="isVideo" :src="media_url" controls preload="auto" type="video/mp4"></video><!-- autoplay -->
                                <img v-else-if="isImage" :src="media_url" alt="">
                            </div>
                            <div v-else class="so-overflow description">
                                <iframe :src="media_url" frameborder="0"></iframe>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "StartModal",
    computed: {
        isVideo() {
            return this.media_url.includes(".mp4") || this.media_url.includes(".webm") || this.media_url.includes(".ogg");
        },
        isImage() {
            return this.media_url.includes(".jpg") || this.media_url.includes(".png");
        },
        isPdf() {
            return this.media_url.includes(".pdf");
        },
    },
    data() {
        return {
            media_url: '',
        }
    },
    mounted() {
        this.media_url = this.$store.getters["current_session"].start_modal_url;
        // console.log('!!!!!!!!!', this.media_url);
    },
    methods:{
        closeIt(){
            this.$app.sendToUnity('StartModalClosed', {});
            this.$app.start_modal_show = false;
        },
    }
}
</script>
<style scoped lang="scss">
#start_modal_wrap{
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    font-family: 'Titillium Web', sans-serif;
    display: flex;
    z-index: 997;
    .start_modal_overlay{
        position:fixed;
        width:100%;
        height: 100%;
        top: 0;
        left: 0;
        background: #000;
        z-index: 1;
        opacity: .5;
    }
    .start_modal{
        background: rgba(0, 0, 0, 0.4);
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
        backdrop-filter: blur(10px);
        border-radius: 30px;
        position: relative;
        z-index: 2;
        min-width: 300px;
        min-height: 140px;
        max-width: 820px;
        width: auto;
        display: flex;
        left: auto;
        right: auto;
        align-self: center;
        margin: 0 auto;
        max-height: 100%;
        overflow: hidden;
        .start_modal_inner{
            position: relative;
            width: 100%;
            // height: 100%;
            padding: 50px;
            box-sizing: border-box;
            .start_modal_inner_wrap{
                height: 100%;
                overflow: auto;
                // overflow: hidden;
            }
        }
        .each_wrap{
            display: flex;
            height: 100%;
            &.centered{
                text-align: center;
                justify-content: center;
            }
        }
        .info_wrap{
            width: 100%;
        }
        .media_wrap{
            flex: 0 0 40%;
            max-width: 600px;
            margin: 0 auto;
            img{
                // width: auto;
                max-width: 100%;
                vertical-align: top;
            }
            video{
                max-width: 100%;
                vertical-align: top;
            }
        }
    }
}

#start_modal_wrap .start_modal .start_modal_close{
    background: none;
    border: none;
    color: white;
    position: absolute;
    right: 25px;
    top: 20px;
    font-size: 30px;
    padding: 0;
    margin: 0;
    line-height: 0;
    cursor: pointer;
}

.material-symbols-outlined {
    font-family: 'Material Icons',serif;
    font-size: 2rem;
    font-weight: 400;
    line-height: 1;
    color: white;

    font-variation-settings:
        'FILL' 1,
        'wght' 400,
        'GRAD' 0,
        'opsz' 24;
}

/* SMART OVERFLOW */
#start_modal_wrap .start_modal .s-overflow-wrap{
    display: flex;
    flex-direction: column;
}
#start_modal_wrap .start_modal .s-overflow-wrap .so-exclude{
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
#start_modal_wrap .start_modal .s-overflow-wrap .so-overflow{
    // max-height: 46.2%;
    // max-height: 86%;
    overflow: auto;
    overflow-x: hidden;
    padding-right: 5px;
    scrollbar-width: thin;
    scrollbar-color: #33BCEEE5 rgba(255,255,255,.5);
}
#start_modal_wrap .start_modal .info_wrap .description iframe{
    width: 650px;
    height: 420px;
}

@media only screen and (max-width: 1000px) {
    #start_modal_wrap .start_modal .info_wrap .description iframe{
        width: 100%;
        height: auto;
    }
}
@media only screen and (max-width: 600px) {
    #start_modal_wrap {
        margin: 10px;
        width: calc(100% - 20px);
    }
    #start_modal_wrap .start_modal {
        max-height: 70%;
    }
    #start_modal_wrap .start_modal .start_modal_inner {
        padding: 30px;
    }
    #start_modal_wrap .start_modal .info_wrap h2 {
        font-size: 24px;
        line-height: 28px;
    }
}
</style>